import { Icon } from '@navinc/base-react-components/wayfinder'
import * as RadixAccordion from '@radix-ui/react-accordion'
import { useEffect, useState } from 'react'

import { useScreenSizeListener } from '@/app/_hooks/use-screen-size-listener.js'
import { useScrollToLocationHashIdOnPage } from '@/app/_hooks/use-scroll-to-id.js'

import { SmartLink } from '../SmartLink/SmartLink.jsx'

type ArticleTableOfContentsProps = {
  data: { text?: string | null; idAttribute?: string | null }[]
}

export const ArticleTableOfContents = ({ data }: ArticleTableOfContentsProps) => {
  const { isMobile } = useScreenSizeListener()
  const [accordionValue, setAccordionValue] = useState<string | undefined>(undefined)

  useScrollToLocationHashIdOnPage()

  useEffect(() => {
    // Set the accordion to be open on desktop and closed on mobile
    setAccordionValue(isMobile ? undefined : 'table-of-contents')
  }, [isMobile])

  return (
    <div className="m-auto print:hidden" data-testid="table-of-contents">
      <RadixAccordion.Root
        className={` mx-auto my-0 flex w-full max-w-[946px] flex-col items-start overflow-hidden rounded-200 border border-outlineVariant bg-surfaceBright`}
        type="single"
        collapsible
        value={accordionValue}
        onValueChange={(value) => setAccordionValue(value)}
      >
        <RadixAccordion.Item className="w-full" value="table-of-contents">
          <RadixAccordion.Header
            className="mx-0 flex items-center gap-[10px] self-stretch p-150"
            data-testid="accordion-header:table-of-contents"
            asChild
          >
            <RadixAccordion.Trigger className="body1 md:title2-emphasized flex w-full justify-between text-onSurface">
              <span className="text-onSurface">Table of contents</span>
              <div className="text-primary">
                <Icon name="keyboard_arrow_down" />
              </div>
            </RadixAccordion.Trigger>
          </RadixAccordion.Header>
          <RadixAccordion.Content>
            <div className="w-full px-150 pt-150 md:max-h-[35vh] md:overflow-y-auto">
              <ol className="flex flex-col gap-200">
                {data.map((heading) => {
                  if (!heading.text || !heading.idAttribute) {
                    return null
                  }
                  return (
                    <li key={heading.idAttribute} className="flex h-full list-decimal">
                      <SmartLink to={`#${heading.idAttribute}`} className="body1 text-start text-onSurface">
                        {heading.text}
                      </SmartLink>
                    </li>
                  )
                })}
              </ol>
              <div className="flex w-full p-100" />
            </div>
          </RadixAccordion.Content>
        </RadixAccordion.Item>
      </RadixAccordion.Root>
    </div>
  )
}
